// extracted by mini-css-extract-plugin
export default {"aboutDiv":"About_aboutDiv__GmPgR","map":"About_map__i7P-s"};